export default __webpack_public_path__ + "static/media/mc_controls.6ff2f680.svg";